import { SerdeContextProviderClass } from '@zaoblako/shared/modules/serde/classes/serde-context-provider.class';
import { SerdeEnvironmentEnum } from '@zaoblako/shared/modules/serde/enums/serde-environment.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import type { SerdeTransformTypeEnum } from '@zaoblako/shared/modules/serde/enums/serde-transform-type.enum';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';
import type { ApiErrorInterface } from '@zaoblako/shared/common/dtos/api-error.dto';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ValidationService {
  public constructor(
    private readonly globalService: GlobalService
  ) {}

  public init(): void {
    const provider = SerdeContextProviderClass.getInstance();
    provider.getBaseContext = (transform?: SerdeTransformTypeEnum) => ({
      transform,
      environment: SerdeEnvironmentEnum.FRONTEND,
      data: {
        tenant: this.globalService.globalInfo?.tenantInfo,
        requiredAnalyticalFeatures: this.globalService.globalInfo?.requiredAnalyticalFeatures,
        planFactSettings: this.globalService.globalInfo?.planFactSettings
      }
    });
  }

  public parseAndValidate<T, D extends SerdeContextDataInterface = SerdeContextDataInterface>(
    value: unknown,
    form: SerdeDtoClass<T, D>,
    contextData?: D,
  ): [T, ApiErrorInterface<T>] {
    return form.validateSyncSafe(value, contextData);
  }
}
